import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Login from './Authentications/Login';
import { Nav } from './Components/Nav';
import Dashboard from './Components/Dashboard';
import { Reset } from './Authentications/Resest';
import { Forgot } from './Authentications/Forgot';
import Register from './Authentications/Register';
import UserComponent from './Authentications/UserComponent';
import UserAccount from './Authentications/UserAccount';
import Sidebar from './Components/Sidebar';
import CategoryComponent from './Categories/Category';
import ProductComponent from './Products/ProductComponent';
import PurchaseComponent from './Purchase/Purchase ';
import AddPurchaseComponent from './Purchase/Addpurchase';
import SupplierComponent from './Suppliers/SupplierComponent';
import CustomerComponent from './Customers/Customers';
import ExpenseComponent from './Expenses/ExpenseComponent';
import SalesComponent from './Sales/SalesComponent';
import AddSaleComponent from './Sales/AddSalesComponent';
import SalesReport from './Sales/SalesReport';
import AddProductComponent from './Products/AddProducts';
import ExpenseReport from './Expenses/ExpenseReport';
import PurchaseReport from './Purchase/PurchaseReport';
import SalesReturnComponent from './Sales/SalesReturn';
import AddSaleReturnComponent from './Sales/AddSAleReturn';
import PurchaseReturnComponent from './Purchase/PurchseReturn';
import AddPurchaseReturnComponent from './Purchase/AddPurchaseReturn';
import PosComponent from './pos/PosComponent';
import Pos from './pos/Pos';
import DebtComponent from './Debts/ShowDebts';
import IncomeAndExpenses from './Income/IncomeAndExpenses';
import BranchList from './Branches/BranchList';
import BranchForm from './Branches/BranchForm';
import RegisterBranches from './Branches/RegisterBranch';
import NotFound from './Components/NotFound';
import ProtectedRoute from './Components/ProtectedRoute';
import BottomNav from './Components/BottomNav';

function MainLayout() {
  const location = useLocation();
  const [isSidebarVisible, setIsSidebarVisible] = React.useState(window.innerWidth > 980);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 980) {
        setIsSidebarVisible(true);
      } else {
        setIsSidebarVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <BottomNav />
      {location.pathname !== '/pos' && (
        <Sidebar isVisible={isSidebarVisible} toggleSidebar={toggleSidebar} />
      )}
      {(location.pathname !== '/' && location.pathname !== '/forgot' && location.pathname !== '/pos') && (
        <Nav toggleSidebar={toggleSidebar} />
      )}

      <Routes>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/xarun" element={<ProtectedRoute><BranchList /></ProtectedRoute>} />
        <Route path="/kudar-xarun" element={<ProtectedRoute><BranchForm /></ProtectedRoute>} />
        <Route path="/kudar-qof" element={<ProtectedRoute><RegisterBranches /></ProtectedRoute>} />
        {/* Users */}
        <Route path="/" element={<Login />} />
        <Route path="/reset/:token" element={<Reset />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/register" element={<ProtectedRoute><Register /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><UserComponent /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><UserAccount /></ProtectedRoute>} />
        {/* Category */}
        <Route path="/categories" element={<ProtectedRoute><CategoryComponent /></ProtectedRoute>} />
        {/* Products */}
        <Route path="/products" element={<ProtectedRoute><ProductComponent /></ProtectedRoute>} />
        <Route path="/add-products" element={<ProtectedRoute><AddProductComponent /></ProtectedRoute>} />
        {/* Purchases */}
        <Route path="/purchase" element={<ProtectedRoute><PurchaseComponent /></ProtectedRoute>} />
        <Route path="/purchase-return" element={<ProtectedRoute><PurchaseReturnComponent /></ProtectedRoute>} />
        <Route path="/add-purchase" element={<ProtectedRoute><AddPurchaseComponent /></ProtectedRoute>} />
        <Route path="/add-purchase-return" element={<ProtectedRoute><AddPurchaseReturnComponent /></ProtectedRoute>} />
        {/* Sippliers */}
        <Route path="/suppliers" element={<ProtectedRoute><SupplierComponent /></ProtectedRoute>} />
        {/* customers */}
        <Route path="/customers" element={<ProtectedRoute><CustomerComponent /></ProtectedRoute>} />
        {/* Expenses */}
        <Route path="/expenses" element={<ProtectedRoute><ExpenseComponent /></ProtectedRoute>} />
        {/* Sales */}
        <Route path="/sales" element={<ProtectedRoute><SalesComponent /></ProtectedRoute>} />
        <Route path="/add-sale" element={<ProtectedRoute><AddSaleComponent /></ProtectedRoute>} />
        <Route path="/sales-return" element={<ProtectedRoute><SalesReturnComponent /></ProtectedRoute>} />
        <Route path="/add-sales-return" element={<ProtectedRoute><AddSaleReturnComponent /></ProtectedRoute>} />
        <Route path="/sale-report" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
        {/* {Pos} */}
        <Route path="/pos" element={<ProtectedRoute><Pos /></ProtectedRoute>} />

        {/* Reports */}
        <Route path="/expense-report" element={<ProtectedRoute><ExpenseReport /></ProtectedRoute>} />
        <Route path="/purchase-report" element={<ProtectedRoute><PurchaseReport /></ProtectedRoute>} />
        {/* Debts */}
        <Route path="/debts" element={<ProtectedRoute><DebtComponent /></ProtectedRoute>} />
        {/* Income */}
        <Route path="/income" element={<ProtectedRoute><IncomeAndExpenses /></ProtectedRoute>} />

        {/* 404 Not Found */}
        <Route path="*" element={<NotFound />} />


      </Routes>
    </>
  )
}


function App() {
  return (
    <BrowserRouter>
      <MainLayout />
    </BrowserRouter>
  );
}

export default App;
